import { render, staticRenderFns } from "./ModalVip.vue?vue&type=template&id=ba9b5946&scoped=true"
import script from "./ModalVip.vue?vue&type=script&lang=js"
export * from "./ModalVip.vue?vue&type=script&lang=js"
import style0 from "./ModalVip.vue?vue&type=style&index=0&id=ba9b5946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9b5946",
  null
  
)

export default component.exports